import * as React from 'react';

function ImageIcon(props) {
  return (
    <svg width='31' height='31' viewBox='0 0 31 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d)'>
        <circle
          r='11.4883'
          transform='matrix(0.999999 -0.00101888 0.000798652 1 16.4975 14.5)'
          fill='white'
        />
        <path
          d='M20.7778 9L12.2222 9C11.55 9 11 9.55 11 10.2222L11 18.7778C11 19.45 11.55 20 12.2222 20L20.7778 20C21.45 20 22 19.45 22 18.7778L22 10.2222C22 9.55 21.45 9 20.7778 9ZM20.7778 10.2222L20.7778 18.7778L12.2222 18.7778L12.2222 10.2222L20.7778 10.2222ZM20.1056 15.4167C19.9222 15.1111 19.4944 14.9889 18.7611 14.9889C18.5167 14.9889 18.2722 14.9889 18.0278 15.05C17.8444 14.9278 17.6611 14.8056 17.5389 14.6833C17.1722 14.3778 16.8056 13.8278 16.6222 13.1556L16.6222 13.0944C16.8056 12.3 16.9889 11.3833 16.6222 10.9556C16.4389 10.8944 16.3167 10.8333 16.1944 10.8333L16.0722 10.8333C15.8278 10.8333 15.6444 11.0778 15.5833 11.2611C15.3389 12.0556 15.5222 12.4833 15.7056 13.2167C15.5833 13.7667 15.3389 14.3167 15.0944 14.9278C14.85 15.3556 14.6667 15.7222 14.4833 16.0278C14.2389 16.15 14.0556 16.2111 13.9333 16.3333C13.2611 16.7611 12.8944 17.25 12.8333 17.5556L12.8333 17.8611L13.1389 18.0444C13.2611 18.1667 13.3222 18.1667 13.4444 18.1667C13.9333 18.1667 14.4833 17.6167 15.2167 16.3333L15.2778 16.3333C15.8889 16.15 16.6222 16.0278 17.6611 15.9056C18.2722 16.2111 19.0056 16.3333 19.4333 16.3333C19.6778 16.3333 19.8611 16.2722 19.9833 16.15C20.1056 16.0278 20.1667 15.9056 20.1667 15.7833C20.1667 15.6 20.1667 15.4778 20.1056 15.4167ZM13.3222 17.7389C13.3222 17.4944 13.6278 17.1278 14.0556 16.7611C14.1167 16.7 14.2389 16.6389 14.3611 16.5778C13.9333 17.25 13.5667 17.6778 13.3222 17.7389ZM16.0722 11.2611C16.0722 11.2611 16.0722 11.2 16.1333 11.2L16.1944 11.2C16.3167 11.3222 16.3167 11.5056 16.2556 11.8722L16.2556 11.9944C16.1944 12.1167 16.1944 12.3 16.1333 12.4833C15.95 11.9333 15.95 11.5056 16.0722 11.2611ZM15.3389 15.9056L15.2778 15.9056C15.3389 15.7222 15.4611 15.5389 15.5833 15.2944C15.8278 14.8056 16.0722 14.3167 16.1944 13.8889C16.4389 14.4389 16.7444 14.8667 17.1111 15.1722C17.1722 15.2333 17.2944 15.2944 17.3556 15.3556C16.8056 15.4167 16.0722 15.6 15.3389 15.9056ZM19.7389 15.8444L19.6167 15.8444C19.3722 15.8444 18.9444 15.7222 18.5167 15.5389C18.5778 15.4778 18.6389 15.4778 18.6389 15.4778C19.4944 15.4778 19.6778 15.6 19.7389 15.6611L19.8 15.7222C19.8 15.8444 19.8 15.8444 19.7389 15.8444Z'
          fill='#08A88E'
        />
      </g>
      <defs>
        <filter
          id='filter0_d'
          x='0.00927734'
          y='0.0117188'
          width='30.9766'
          height='30.9766'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-1' dy='1' />
          <feGaussianBlur stdDeviation='2' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
        </filter>
      </defs>
    </svg>
  );
}

export default ImageIcon;
